export default __webpack_public_path__ + "static/date-label-do-2-dark-d107b067323226ce0789402aa159bda2.png";